<template>
    <BreadCrumb PageTitle="Liste Suivi client" />
    <ListeSuivClient />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeSuivClient from "../../components/Etats/ListeSuivClient.vue";

    export default defineComponent({
        name: "ListeSuivClientPage",
        components: {
            BreadCrumb,
            ListeSuivClient,
        },
    });
</script>